import {
  ActiveFilterHttpParamNameMap,
  ActiveFilterHttpValueTransformMap,
  FilterMenuConfig,
} from '../../types/filter.type';
import { DISTANCE_FILTER_HTTP_PARAM_NAMES, DISTANCE_FILTERS } from './distance-filter';
import {
  DURATION_FILTER_HTTP_PARAM_NAMES,
  DURATION_FILTER_HTTP_VALUE_TRANSFORM,
  DURATION_FILTERS,
} from './duration-filter';
import { COUNTRY_FILTERS } from './country-filter';
import { LEVEL_FILTERS } from './level-filters';
import { SLOPE_FILTER_HTTP_PARAM_NAMES, SLOPE_FILTERS } from './slope-filter';
import { SPORT_FILTERS } from './sport-filter';
import { STATUS_FILTERS } from './status-filter';
import { TITLE_FILTERS } from './title-filter';
import { UPLOAD_FILTERS } from './upload-filter';

export const FILTERS: Record<string, FilterMenuConfig> = {
  duration: DURATION_FILTERS,
  distance: DISTANCE_FILTERS,
  slope: SLOPE_FILTERS,
  level: LEVEL_FILTERS,
  sport: SPORT_FILTERS,
  country: COUNTRY_FILTERS,
  title: TITLE_FILTERS,
  status: STATUS_FILTERS,
  upload: UPLOAD_FILTERS,
  labels: {
    sortable: false,
    filters: [],
  },
};

export const SORT_HTTP_PARAM_NAMES: ActiveFilterHttpParamNameMap = {
  upload: 'upload_date',
  level: 'difficulty',
  sessions: 'activityCompleted',
  title: 'alphabetic',
  country: 'countryName',
  likes: 'like',
  comments: 'comment',
};

export const FILTER_HTTP_PARAM_NAMES: ActiveFilterHttpParamNameMap = {
  distance: DISTANCE_FILTER_HTTP_PARAM_NAMES,
  duration: DURATION_FILTER_HTTP_PARAM_NAMES,
  slope: SLOPE_FILTER_HTTP_PARAM_NAMES,
  level: 'difficulties[]',
  title: 'term',
  country: 'location',
  upload: 'upload_date[]',
};

export const FILTER_HTTP_VALUE_TRANSFORMS: ActiveFilterHttpValueTransformMap = {
  duration: DURATION_FILTER_HTTP_VALUE_TRANSFORM,
};
